import React from "react";
import { getOption } from "../../../API/swesum";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import OptionsTable from "./components/OptionsTable";
import MainLayout1 from "Components/UI/Layout/MainLayout1";


export async function loader() {
  const option = await getOption();
  return { option };
}

export function Options() {
  const navigate = useNavigate();

  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Inställningar</Typography>
          <Button
            onClick={() => navigate("create")}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            SKAPA NY
          </Button>
        </Box>
        <OptionsTable />
      </MainLayout1>
    </>
  );
}
